import { useCallback, useRef } from 'react';

export default <T>(initialValue?: T | null) => {
  const ref = useRef<T | null>(initialValue ?? null);

  const setValue = useCallback((value: T) => {
    ref.current = value;
  }, []);

  const clearValue = useCallback(() => {
    ref.current = null;
  }, []);

  return { ref, setValue, clearValue };
};
